import TelephoneIcon from "./TelephoneIcon"

export default  TelephoneIcon;
